import { useTranslation } from 'react-i18next';

function useLanguage() {
  const { t } = useTranslation();
  const language = {
    //#region Footer
    footer: t('footer.title'),
    //#endregion

    dashboard: {
      titleHeader: t('pages.dashboard.header.title'),
      titleTotalRevenueReport: t('pages.dashboard.report_total_revenue'),
      chartYear: t('pages.dashboard.chart_year'),
      title: t('pages.dashboard.title'),
      slogan: t('pages.dashboard.slogan'),
      title_card_1: t('pages.dashboard.title_card_1'),
      titleCard1Year: t('pages.dashboard.title_card_1_year'),
      titleCard1Year_7days: t('pages.dashboard.title_card_1_7days'),
      title_card_2: t('pages.dashboard.title_card_2'),
      titleCard2Year: t('pages.dashboard.title_card_2_year'),
      titleCard2Year_7days: t('pages.dashboard.title_card_2_7days'),
      title_card_3: t('pages.dashboard.title_card_3'),
      titleCard4Year: t('pages.dashboard.title_card_4_year'),
      title_card_4: t('pages.dashboard.title_card_4'),
      titleCard4Year_7days: t('pages.dashboard.title_card_4_7days'),
      descCard1: t('pages.dashboard.desc_card_1'),
      descCard2: t('pages.dashboard.desc_card_2'),
      descCard3: t('pages.dashboard.desc_card_3'),
      typeMonth: t('pages.dashboard.type_month'),
      typeYear: t('pages.dashboard.type_year'),
      type7Ago: t('pages.dashboard.type_seven_ago'),
      filter: t('pages.dashboard.filter')
    },

    modulesMenu: {
      dashboard: t('modules_menu.dashboard'),
      users: t('modules_menu.users'),
      reportMangement: t('modules_menu.report_mangement.title'),
      digitalReport: t('modules_menu.report_mangement.digital_report'),
      saleReport: t('modules_menu.report_mangement.sales_report'),
      systemMangement: t('modules_menu.system_mangement.title'),
      team: t('modules_menu.system_mangement.team'),
      expectedRevenue: t('modules_menu.system_mangement.expected_revenue'),
      closingSales: t('modules_menu.system_mangement.closing_sales'),
      uploadPushsale: t('modules_menu.system_mangement.upload_pushsale'),
      marketingFee: t('modules_menu.system_mangement.marketing_fee'),
      mangement: t('modules_menu.heading.mangement'),
      report: t('modules_menu.heading.report'),
      contactReport: t('modules_menu.report_mangement.contact_report'),
      destinyReport: t('modules_menu.report_mangement.destiny_report'),
      refundRateReport: t('modules_menu.report_mangement.refund_rate_report'),
      omicallReport: t('modules_menu.report_mangement.omicall_report'),
      sysPermissions: t('modules_menu.system_mangement.permissions_page'),
      sysRolePermissions: t('modules_menu.system_mangement.permission_role'),
      digitalManagement: {
        name: t('modules_menu.digital_management.name'),
        childrentModule: {
          setupDigitalMarketing: {
            name: t('modules_menu.digital_management.childrent_module.setup_digital_marketing.name')
          },
          adsCost: {
            name: t('modules_menu.digital_management.childrent_module.ads_cost.name'),
            index: t('modules_menu.digital_management.childrent_module.ads_cost.index')
          }
        }
      },
      socialManagement: {
        name: t('modules_menu.social_management.name'),
        childrentModule: {
          socialIndex: {
            name: t('modules_menu.social_management.childrent_module.social_index.name')
          }
        }
      }
    },

    signOut: {
      title: t('pages.sign_out.title')
    },

    forgotPassword: {
      title: t('pages.forgot_password.title'),
      labelEmail: t('pages.forgot_password.label_email'),
      linkSignin: t('pages.forgot_password.link_signin'),
      titleUpdatePassword: t('pages.forgot_password.title_update_password'),
      titleNewPassword: t('pages.forgot_password.label_new_password'),
      titleReTypePassword: t('pages.forgot_password.label_reType_password'),
      validations: {
        email: {
          required: t('common.validation.required', { name: t('pages.forgot_password.label_email') }),
          invalid: t('common.validation.invalid', { name: 'Email' })
        },
        newPassword: {
          required: t('common.validation.required', {
            name: t('pages.forgot_password.label_new_password')
          }),
          min: t('common.validation.min', { name: t('pages.forgot_password.label_new_password'), number: '8' })
        },
        reTypeNewPassword: {
          required: t('common.validation.required', {
            name: t('pages.forgot_password.label_reType_password')
          }),
          min: t('common.validation.min', { name: t('pages.forgot_password.label_reType_password'), number: '8' }),
          notMatches: t('common.validation.doest_matches', {
            name_1: t('pages.forgot_password.label_reType_password'),
            name_2: t('pages.forgot_password.label_new_password')
          })
        }
      }
    },

    signInPage: {
      title: t('pages.signin.title'),
      userName: t('pages.signin.userName'),
      password: t('pages.signin.password'),
      btnRegister: t('pages.signin.btnRegister'),
      forgetPass: t('pages.signin.forgetPass'),
      validation: {
        userName: {
          required: t('common.validation.required', { name: t('pages.signin.userName') }),
          min: t('common.validation.min', { name: 'Username', number: '3' }),
          max: t('common.validation.max', { name: 'Username', number: '20' })
        },
        password: {
          required: t('common.validation.required', { name: t('pages.signin.password') }),
          formatPassword: t('common.validation.formatPassword')
        },
        inCorrect: t('pages.signin.validation.login_failed')
      }
    },
    product: {
      titleHeader: t('product.title'),
      productTablePage: {
        buttonCreateProduct: t('product.productTablePage.buttonCreateProduct')
      }
    },
    profilePage: {
      headerTitle: t('pages.profile.header.title'),
      editProfile: t('common.buttons.edit_profile'),
      cardAddress: t('common.buttons.card_address'),
      notifications: t('common.buttons.notifications'),
      permissionTab: t('common.buttons.permission'),
      security: t('common.buttons.security'),

      facebook: t('pages.profile.facebook'),
      changeCover: t('pages.profile.change_cover'),

      title: t('pages.profile.edit_profile_tab.title'),
      myProfile: t('pages.profile.title'),
      sologan: t('pages.profile.edit_profile_tab.sologan'),
      labelFirstName: t('pages.profile.edit_profile_tab.label_first_name'),
      labelLastName: t('pages.profile.edit_profile_tab.label_last_name'),
      labelDisplayName: t('pages.profile.edit_profile_tab.label_display_name'),
      labelName: t('pages.profile.edit_profile_tab.label_name'),
      labelBirthDay: t('pages.profile.edit_profile_tab.label_birth_date'),
      labelAddress: t('pages.profile.edit_profile_tab.label_address'),
      labelEmail: t('pages.profile.edit_profile_tab.label_email'),
      labelPhoneNumber: t('pages.profile.edit_profile_tab.label_phone_number'),
      labelGender: t('pages.profile.edit_profile_tab.label_gender'),
      labelRole: t('pages.profile.edit_profile_tab.label_role'),
      labelParent: t('pages.profile.edit_profile_tab.label_parent'),
      labelWonman: t('pages.profile.edit_profile_tab.label_woman'),
      labelMan: t('pages.profile.edit_profile_tab.label_man'),
      labelOther: t('pages.profile.edit_profile_tab.label_other'),

      titleAddressSetting: t('pages.profile.address_settings.title'),
      sologanAddressSetting: t('pages.profile.address_settings.sologan'),
      labelAddressFull: t('pages.profile.address_settings.label_address_full'),
      labelCountry: t('pages.profile.address_settings.label_country'),
      placehodlerCountry: t('pages.profile.address_settings.placeholder_country'),
      labelProvince: t('pages.profile.address_settings.label_province'),
      placehodlerProvince: t('pages.profile.address_settings.placeholder_province'),
      labelDistrict: t('pages.profile.address_settings.label_district'),
      placehodlerDistrict: t('pages.profile.address_settings.placeholder_district'),
      labelWard: t('pages.profile.address_settings.label_ward'),
      placehodlerWard: t('pages.profile.address_settings.placeholder_ward'),

      titleIndentityCard: t('pages.profile.identity_card.title'),
      labelNoIdentity: t('pages.profile.identity_card.label_no_identity'),
      labelPlaceIssue: t('pages.profile.identity_card.label_place_issue'),
      placeholderPlaceIssue: t('pages.profile.identity_card.placeholder_place_issue'),
      labelIssueDate: t('pages.profile.identity_card.label_issue_date'),

      titlePermission: t('pages.profile.permisison.title'),
      subTitlePermission: t('pages.profile.permisison.sub_title'),
      roleTitle: t('pages.profile.permisison.role_title'),
      roleHeader: t('pages.profile.permisison.role_header'),
      functionTitle: t('pages.profile.permisison.function_title'),
      functionHeader: t('pages.profile.permisison.function_header'),
      moduleName: t('pages.profile.permisison.module_name'),
      pageName: t('pages.profile.permisison.page_name'),
      functionName: t('pages.profile.permisison.function_name'),
      roleName: t('pages.profile.permisison.role_name'),
      permissionStatus: t('pages.profile.permisison.permission_status'),
      permissionTool: t('pages.profile.permisison.permission_tool'),
      detailUserPage: {
        editTitle: t('pages.profile.detail_user.edit_title')
      },
      //#region Users module
      usersTablePage: {
        buttonCreateUser: t('common.buttons.create_user'),
        titleListUser: t('pages.profile.users_table.title_list_user'),
        filterPlaceHolder: t('pages.profile.users_table.placeholder_search'),
        columnCode: t('pages.profile.users_table.column_code'),
        columnName: t('pages.profile.users_table.column_name'),
        columnPosition: t('pages.profile.users_table.column_position'),
        columnPhone: t('pages.profile.users_table.column_phone'),
        columnStatus: t('pages.profile.users_table.column_status'),
        columnAction: t('pages.profile.users_table.column_action'),
        userInfomation: t('pages.profile.users_table.user_information'),
        titleEdited: t('pages.profile.users_table.title_edited'),
        titleRolePermission: t('pages.profile.users_table.title_role_permission'),
        labelUserName: t('pages.profile.users_table.title_username'),
        labelCode: t('pages.profile.users_table.title_code'),
        breadCrumbCreate: t('pages.profile.users_table.breadcrumb_create'),
        breadCrumbModify: t('pages.profile.users_table.breadcrumb_modify')
      },

      //#endregion

      validation: {
        fristName: {
          required: t('common.validation.required', {
            name: t('pages.profile.edit_profile_tab.label_first_name')
          }),
          min: t('common.validation.min', { name: 'FristName', number: '2' }),
          max: t('common.validation.max', { name: 'FristName', number: '20' })
        },
        lastName: {
          required: t('common.validation.required', {
            name: t('pages.profile.edit_profile_tab.label_last_name')
          }),
          min: t('common.validation.min', { name: 'FristName', number: '2' })
        },
        phoneNumber: {
          required: t('common.validation.required', {
            name: t('pages.profile.edit_profile_tab.label_phone_number')
          }),
          length: t('common.validation.min', { name: 'Phone Number', number: '10' }),
          onlyNumber: t('validation.onlyNumber', { name: 'Phone Number' })
        },
        email: {
          required: t('common.validation.required', { name: t('pages.profile.edit_profile_tab.label_email') }),
          invalid: t('pages.profile.validation.invalid', { name: 'Email' })
        },
        dob: {
          required: t('common.validation.required', {
            name: t('pages.profile.edit_profile_tab.label_birth_date')
          }),
          invalid: t('pages.profile.validation.invalid', { name: 'Date of Birth' }),
          greaterThan: t('pages.profile.validation.greaterThan')
        },
        identityCard: {
          required: t('common.validation.required', {
            name: t('pages.profile.identity_card.label_no_identity')
          }),
          min: t('common.validation.min', { name: 'Identity Card', number: '9' }),
          max: t('common.validation.max', { name: 'Identity Card', number: '12' }),
          onlyNumber: t('validation.onlyNumber', { name: 'Identity Card' })
        },
        placeIssue: {
          required: t('common.validation.required', { name: t('pages.profile.identity_card.label_place_issue') })
        },
        issuedDate: {
          required: t('common.validation.required', { name: t('pages.profile.identity_card.label_issue_date') }),
          invalid: t('pages.profile.validation.invalid', { name: 'Issue Date' }),
          greaterThan: t('pages.profile.validation.greaterThanIssueDate')
        },
        country: {
          required: t('common.validation.required', { name: t('pages.profile.address_settings.label_country') })
        },
        province: {
          required: t('common.validation.required', { name: t('pages.profile.address_settings.label_province') })
        },
        save_permission: {
          error: t('pages.profile.validation.save_permission', { message: 'failed' }),
          success: t('pages.profile.validation.save_permission', { message: 'success' })
        },
        updateUser: {
          error: t('pages.profile.validation.update_user', { message: 'failed' }),
          success: t('pages.profile.validation.update_user', { message: 'success' })
        },
        updateIdentityCard: {
          error: t('pages.profile.validation.update_identity_card', { message: 'failed' }),
          success: t('pages.profile.validation.update_identity_card', { message: 'success' })
        },
        updateAddress: {
          error: t('pages.profile.validation.update_address', { message: 'failed' }),
          success: t('pages.profile.validation.update_address', { message: 'success' })
        },
        updateProfile: {
          error: t('pages.profile.validation.update_address', { message: 'failed' }),
          success: t('pages.profile.validation.update_address', { message: 'success' })
        },
        deleteUser: {
          error: t('pages.profile.validation.delete_user', { message: 'failed' }),
          success: t('pages.profile.validation.delete_user', { message: 'success' })
        },
        resetPassword: {
          checkEmail: t('pages.profile.validation.reset_password.check_email')
        }
      },

      //#region Setup Account Digital MK
      setupAccountDigitalMK: {
        title: t('pages.profile.setup_digital_marketing.title_header'),
        subTitle: t('pages.profile.setup_digital_marketing.sub_title'),
        labelSocial: t('pages.profile.setup_digital_marketing.label_social'),
        labelSocialUsername: t('pages.profile.setup_digital_marketing.label_social_username'),
        table: {
          columnNo: t('pages.profile.setup_digital_marketing.table.column_no'),
          columnSocial: t('pages.profile.setup_digital_marketing.table.column_social'),
          columnSocialFanpage: t('pages.profile.setup_digital_marketing.table.column_social_fanpage'),
          columnSocialUsername: t('pages.profile.setup_digital_marketing.table.column_social_username'),
          columnSocialStatus: t('pages.profile.setup_digital_marketing.table.column_status'),
          columnSocialReason: t('pages.profile.setup_digital_marketing.table.column_reason'),
          columnSocialCreated: t('pages.profile.setup_digital_marketing.table.column_created'),
          columnSocialAccount: t('pages.profile.setup_digital_marketing.table.column_social_account'),
          columnSocialAccountId: t('pages.profile.setup_digital_marketing.table.column_social_account_id'),
          columnCurrency: t('pages.profile.setup_digital_marketing.table.column_social_currency'),
          columnOption: t('pages.profile.setup_digital_marketing.table.column_social_option')
        }
      }
      //#endregion
    },

    expectedRevenuePage: {
      titleLinkExpectedRevenue: t('pages.expected_revenue.title_link'),
      labelManagerRevenue: t('pages.expected_revenue.label_manager'),
      placeholderManagerRevenue: t('pages.expected_revenue.placeholder_manager_revenue'),
      placeholderAmountRevenue: t('pages.expected_revenue.placeholder_amount_revenue'),
      placeholderAmount: t('pages.expected_revenue.placeholder_amount'),
      placeholderRate: t('pages.expected_revenue.placeholder_rate'),
      labelMonthlyPickerRevenue: t('pages.expected_revenue.label_monthly_picker_revenue'),
      selectTypeLabel: t('pages.expected_revenue.select_type'),
      selectExpectedLabel: t('pages.expected_revenue.select_expected'),
      selectAverageLabel: t('pages.expected_revenue.select_average'),
      selectClosingLabel: t('pages.expected_revenue.select_closing'),
      selectRefundLabel: t('pages.expected_revenue.select_refund'),
      headerExpected: t('pages.expected_revenue.header_expected'),
      headerMember: t('pages.expected_revenue.header_member'),
      headerAverage: t('pages.expected_revenue.header_average'),
      headerClosing: t('pages.expected_revenue.header_closing'),
      headerRefund: t('pages.expected_revenue.header_refund'),
      validation: {
        saveExpectedRevenue: {
          error: t('pages.expected_revenue.validation.save_expected_revenue', { message: 'failed' }),
          success: t('pages.expected_revenue.validation.save_expected_revenue', { message: 'success' })
        }
      }
    },

    salesClosingPage: {
      titleLinkSalesClosing: t('pages.sales_closing.title_page'),
      totalContact: t('pages.sales_closing.total_contact'),
      totalSaleClosing: t('pages.sales_closing.total_sales_closing'),
      labelManagerSaleClosing: t('pages.sales_closing.label_manager'),
      placeholderManagerSaleClosing: t('pages.sales_closing.placeholder_manager_sale_closing'),
      labelMonthlyPickerSaleClosing: t('pages.sales_closing.label_monthly_picker_sale_closing'),
      validation: {
        saveSaleClosing: {
          error: t('pages.sales_closing.validation.save_sales_closing', { message: 'failed' }),
          success: t('pages.sales_closing.validation.save_sales_closing', { message: 'success' })
        }
      }
    },

    teamsPage: {
      teamTitle: t('pages.team.team_title'),
      addMember: t('pages.team.add_member'),
      placeholderFindUser: t('pages.team.placeholder_find_user'),
      listMemberSelect: t('pages.team.list_member_select')
    },
    settingPage: {
      settingTitle: t('pages.setting.setting_title')
    },

    uploadFilePushSalePage: {
      titlePageUploadFile: t('pages.upload_file_pushsale.title_page'),
      titleAcceptUpload: t('pages.upload_file_pushsale.title_accept_upload'),
      subtitleTemplate: t('pages.upload_file_pushsale.subtitle_template'),
      linkDownload: t('pages.upload_file_pushsale.link_download'),
      titleDragDrop: t('pages.upload_file_pushsale.title_drag_drop'),
      titleBrowseFile: t('pages.upload_file_pushsale.title_browse_file'),
      validation: {
        saveFilePushsale: {
          error: t('pages.upload_file_pushsale.validation.save_file_pushsale', { message: 'failed' }),
          success: t('pages.upload_file_pushsale.validation.save_file_pushsale', { message: 'success' })
        },
        attachFilePushsale: t('pages.upload_file_pushsale.validation.attach_file')
      }
    },

    //#region Digital report
    digitalReportPage: {
      titleHeader: t('pages.digital_report.title_header'),
      startDate: t('pages.digital_report.startDate'),
      endDate: t('pages.digital_report.endDate'),
      teamName: t('pages.digital_report.team_name'),
      teamLead: t('pages.digital_report.team_lead'),
      to: t('pages.digital_report.to'),
      validation: {
        userId: {
          required: t('common.validation.required', { name: t('pages.digital_report.team_lead') })
        },
        startDate: {
          required: t('common.validation.required', { name: t('pages.digital_report.startDate') })
        },
        endDate: {
          required: t('common.validation.required', { name: t('pages.digital_report.endDate') })
        }
      }
    },
    //#endregion

    //#region Sales report
    salesReportsPage: {
      titleHeader: t('pages.sales_report.title_header'),
      startDate: t('pages.sales_report.startDate'),
      teamName: t('pages.sales_report.team_name'),
      teamLead: t('pages.sales_report.team_lead'),
      validation: {
        userId: {
          required: t('common.validation.required', { name: 'Team' })
        },
        startDate: {
          required: t('common.validation.required', { name: 'Date' })
        }
      }
    },
    //#endregion

    //#region Marketing Fee
    marketingFeePage: {
      titleHeader: t('pages.marketing_fee.title_header'),
      startDate: t('pages.marketing_fee.startDate'),
      endDate: t('pages.marketing_fee.endDate'),
      teamName: t('pages.marketing_fee.team_name'),
      teamLead: t('pages.marketing_fee.team_lead'),
      placeholderAmount: t('pages.marketing_fee.placeholder_amount'),
      to: t('pages.digital_report.to'),
      validation: {
        userId: {
          required: t('common.validation.required', { name: t('pages.marketing_fee.team_name') })
        },
        startDate: {
          required: t('common.validation.required', { name: t('pages.marketing_fee.startDate') })
        },
        endDate: {
          required: t('common.validation.required', { name: t('pages.marketing_fee.endDate') })
        }
      }
    },
    //#endregion

    // #region Destiny Report
    destinyReportPage: {
      titleHeader: t('pages.destiny_report.title_header'),
      destinyType: t('pages.destiny_report.destiny_type'),
      destinyMonth: t('pages.destiny_report.destiny_month'),
      pieChart: {
        totalNorth: t('pages.destiny_report.pie_chart.total_north'),
        totalCentral: t('pages.destiny_report.pie_chart.total_central'),
        totalSouth: t('pages.destiny_report.pie_chart.total_south'),
        totalPushsale: t('pages.destiny_report.pie_chart.total_pushsale'),
        totalPancake: t('pages.destiny_report.pie_chart.total_pancake'),
        totalAll: t('pages.destiny_report.pie_chart.total_all')
      },
      option: {
        destinyProduct: t('pages.destiny_report.option.destiny_product'),
        destinyArea: t('pages.destiny_report.option.destiny_area')
      }
    },
    //#endregion

    // #region Refund Rate Report
    refundRateReport: {
      titleHeader: t('pages.refund_rate_report.title_header')
    },
    // #endregion

    //#region Omicall Report
    omicallReportPage: {
      titleHeader: t('pages.omicall_report.title_header'),
      fromDate: t('pages.omicall_report.from_date'),
      toDate: t('pages.omicall_report.to_date'),
      quantity: t('pages.omicall_report.quantity_call'),
      callIn: t('pages.omicall_report.call_in'),
      callOut: t('pages.omicall_report.call_out'),
      answer: t('pages.omicall_report.answer'),
      noAnswer: t('pages.omicall_report.not_answer'),
      localCall: t('pages.omicall_report.local_call'),
      callQuantity: t('pages.omicall_report.call_quantity'),
      minutes: t('pages.omicall_report.minutes'),
      minuteQuantity: t('pages.omicall_report.minutes'),
      callStatistics: t('pages.omicall_report.call_statistics'),
      callMinuteStatistics: t('pages.omicall_report.call_minute_statistics'),
      totalTimeOneCall: t('pages.omicall_report.total_minute_on_call'),
      averageMinuteOneCall: t('pages.omicall_report.average_minutes_one_call')
    },
    //#endregion

    //#region Permission Page
    permissionPage: {
      title: t('pages.permisison_page.title_header'),
      permissionPerPage: t('pages.permisison_page.title_permisison_per_page'),
      permissionSetting: t('pages.permisison_page.title_permission_setting'),
      titleModule: t('pages.permisison_page.title_module'),
      titlePage: t('pages.permisison_page.title_page'),
      titleFunction: t('pages.permisison_page.title_function')
    },
    permissionRole: {
      title: t('pages.permission_role.title_header'),
      modalTitle: t('pages.permission_role.modal_title')
    },
    //#endreigon

    //#region Digital Management
    digitalManagement: {
      setupDigitalMarketing: {
        titleHeader: t('pages.digital_management.review_social_account.title_header'),
        labelReason: t('pages.digital_management.review_social_account.label_reason'),
        dialog: {
          titleBody: t('pages.digital_management.review_social_account.dialog.title_body'),
          titleBody2: t('pages.digital_management.review_social_account.dialog.title_body2')
        }
      },
      adsCost: {
        titleHeader: t('pages.digital_management.ads_cost.title_header')
      }
    },
    //#endregion

    //#region Social Management
    socialManagement: {
      socialIndex: {
        titleHeader: t('pages.social_management.social_index.title_header')
      }
    },
    //#endregion

    //#region Error page
    errorPage: {
      title: t('pages.error_page.title'),
      subTitle: t('pages.error_page.sub_title')
    },
    //#endregion

    success: {
      resetPassword: {
        checkEmail: t('success.reset_password.check_email')
      }
    },

    common: {
      buttons: {
        edit: t('common.buttons.edit'),
        save: t('common.buttons.save'),
        discard: t('common.buttons.discard'),
        remove: t('common.buttons.remove'),
        cancel: t('common.buttons.cancel'),
        update: t('common.buttons.update'),
        upload: t('common.buttons.upload'),
        submit: t('common.buttons.submit'),
        find: t('common.buttons.find'),
        delete: t('common.buttons.delete'),
        close: t('common.buttons.close'),
        resetPassword: t('common.buttons.reset_password'),
        goBackHome: t('common.buttons.go_back_home'),
        setAll: t('common.buttons.set_all'),
        reset: t('common.buttons.reset'),
        addMore: t('common.buttons.addMore'),
        createNew: t('common.buttons.create_new'),
        refresh: t('common.buttons.refresh'),
        approval: t('common.buttons.approval'),
        reject: t('common.buttons.reject'),
        confirm: t('common.buttons.confirm')
      },
      statusUser: {
        block: t('common.status_user.block'),
        completed: t('common.status_user.completed'),
        pending: t('common.status_user.pending')
      },
      status: {
        pending: t('common.status.pending'),
        approve: t('common.status.approve'),
        reject: t('common.status.reject'),
        block: t('common.status.block'),
        permanentlyBlock: t('common.status.permanently_block'),
        activated: t('common.status.activated'),
        inActivated: t('common.status.inactivated')
      },
      validation: {
        successfully: t('common.successfully'),
        pleaseEnter: t('common.please_enter'),
        notAvalible: t('common.not_avalible')
      },
      tooltip: {
        delete: t('common.tooltip.delete')
      },
      dialog: {
        notification: t('common.dialog.notification')
      }
    }
  };
  return { language };
}

export default useLanguage;
